export default __webpack_public_path__ + "static/media/pictogramBeaconShopping128.18c16009.svg";